import $ from 'jquery';

const ACTIVE = 'active';
const learn = () => {
  const links = $('[data-learn]');
  const allLearnContents = $('.c-learn__content');

  if (links.length) {
    links.on('click', ev => {
      ev.preventDefault();
      const self = ev.target;
      const target = self.hash;
      const $target = $(target);
      if ($target) {
        links.removeClass(ACTIVE);
        self.classList.add(ACTIVE);
        allLearnContents.removeClass(ACTIVE);
        $target.addClass(ACTIVE);
      }
    });
  }
};
export default learn;



// WEBPACK FOOTER //
// ./src/scripts/modules/learn.js